import gql from 'graphql-tag';
import { CatalogItemCardFragment } from '../fragments/fragments.cartEndpoint';

export default {
  getProductsListByIds: gql`
    query getProductsListByIds(
      $ids: [Float!]
      $filters: AppliedFilters
      $orderDir: OrderDir
      $orderBy: ProductSort
    ) {
      getProductsListByIds(
        ids: $ids
        filters: $filters
        orderDir: $orderDir
        orderBy: $orderBy
      ) {
        totalCount
        minPrice
        maxPrice
        availableFilters {
          highRating
          discount
          reviewed
          newbee
          hits
          minPrice
          maxPrice
        }
        catalogItems {
          ...CatalogItemCardFragment
        }
      }
    }
    ${CatalogItemCardFragment}
  `
};
